export default "__VITE_ASSET__BsoxLqUH__"